import { i18n } from '@/plugins/i18n'

/**
 * Mirrors the backend TokenType enum (new-paystar: Modules/User/app/Enums/TokenType.php).
 */
export const applicationTokenTypes = {
    MATTERMOST: 'mattermost',
    MICROSOFT_DYNAMICS: 'microsoft_dynamics',
    MCP: 'mcp',
}

const applicationTokenTypeColors = {
    [applicationTokenTypes.MATTERMOST]: '#0058cc',
    [applicationTokenTypes.MICROSOFT_DYNAMICS]: '#5c2d91',
    [applicationTokenTypes.MCP]: '#d97706',
}

export const applicationTokenTypeLabel = (type) => i18n.t(`application_token.types.${type}`)

export const applicationTokenTypeColor = (type) => applicationTokenTypeColors[type] || '#6c757d'

export const applicationTokenTypeOptions = () => Object.values(applicationTokenTypes)
    .map(value => ({ value, label: applicationTokenTypeLabel(value) }))
